import React from "react";
import { MenuItem, TextField } from "@material-ui/core";
import { buildStationsTextStyle } from "../../../../services/StationsTextConfigService";
import { DrawerLabel, DrawerPreviewBox, DrawerSection } from "../styles";
import type { StationsTextEntry, StationsTextPaletteEntry } from "../types";

interface Props {
	entry: StationsTextEntry;
	palette: StationsTextPaletteEntry[];
	onChange: (patch: Partial<StationsTextEntry>) => void;
}

const FONT_SIZE_OPTIONS = [
	{ value: "sm", label: "Small (0.875rem)" },
	{ value: "md", label: "Medium (1rem)" },
	{ value: "lg", label: "Large (1.125rem)" },
];

const FONT_WEIGHT_OPTIONS = [
	{ value: "normal", label: "Normal" },
	{ value: "bold", label: "Bold" },
];

const FONT_STYLE_OPTIONS = [
	{ value: "normal", label: "Normal" },
	{ value: "italic", label: "Italic" },
];

export default function DrawerStyleTab({ entry, palette, onChange }: Props) {
	const previewStyle = buildStationsTextStyle(entry, palette);

	function handleStyleChange(field: keyof typeof entry.stylePreset, value: string) {
		onChange({ stylePreset: { ...entry.stylePreset, [field]: value } });
	}

	return (
		<div>
			<DrawerSection>
				<DrawerLabel>Font size</DrawerLabel>
				<TextField
					select
					fullWidth
					size="small"
					variant="outlined"
					value={entry.stylePreset.fontSizePreset}
					onChange={(e) => handleStyleChange("fontSizePreset", e.target.value)}>
					{FONT_SIZE_OPTIONS.map((o) => (
						<MenuItem
							key={o.value}
							value={o.value}>
							{o.label}
						</MenuItem>
					))}
				</TextField>
			</DrawerSection>

			<DrawerSection>
				<DrawerLabel>Font weight</DrawerLabel>
				<TextField
					select
					fullWidth
					size="small"
					variant="outlined"
					value={entry.stylePreset.fontWeight}
					onChange={(e) => handleStyleChange("fontWeight", e.target.value)}>
					{FONT_WEIGHT_OPTIONS.map((o) => (
						<MenuItem
							key={o.value}
							value={o.value}>
							{o.label}
						</MenuItem>
					))}
				</TextField>
			</DrawerSection>

			<DrawerSection>
				<DrawerLabel>Font style</DrawerLabel>
				<TextField
					select
					fullWidth
					size="small"
					variant="outlined"
					value={entry.stylePreset.fontStyle}
					onChange={(e) => handleStyleChange("fontStyle", e.target.value)}>
					{FONT_STYLE_OPTIONS.map((o) => (
						<MenuItem
							key={o.value}
							value={o.value}>
							{o.label}
						</MenuItem>
					))}
				</TextField>
			</DrawerSection>

			<DrawerSection>
				<DrawerLabel>Color token</DrawerLabel>
				<TextField
					select
					fullWidth
					size="small"
					variant="outlined"
					value={entry.colorToken}
					onChange={(e) => onChange({ colorToken: e.target.value })}>
					{palette.map((p) => (
						<MenuItem
							key={p.token}
							value={p.token}>
							<span
								style={{
									display: "inline-block",
									width: 12,
									height: 12,
									borderRadius: 2,
									background: p.value,
									marginRight: 8,
									verticalAlign: "middle",
									border: "1px solid #e2e8f0",
								}}
							/>
							{p.label}
						</MenuItem>
					))}
				</TextField>
			</DrawerSection>

			<DrawerSection>
				<DrawerLabel>Preview</DrawerLabel>
				<DrawerPreviewBox>
					{entry.currentText ? (
						<span style={previewStyle}>{entry.currentText}</span>
					) : entry.defaultText ? (
						<span
							style={previewStyle}
							title="Đang xem text gốc từ code (chưa có bản chỉnh sửa)">
							{entry.defaultText}
						</span>
					) : (
						<span style={{ color: "#94a3b8", fontStyle: "italic" }}>(empty)</span>
					)}
				</DrawerPreviewBox>
			</DrawerSection>
		</div>
	);
}
